import { Component, inject } from '@angular/core'
import { MatDialogRef, MatDialogContent, MatDialogActions, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { TranslateModule } from '@ngx-translate/core'
import { FileUploadComponent } from '../../../../file-upload/file-upload.component'
import { DocumentUploadInfo } from '../../../../utils'

export type BoardPackIngestDialogOutputData = {
  uploadKey: string
  fileName: string
}

@Component({
  selector: 'app-board-pack-ingest-dialog',
  imports: [MatDialogContent, MatDialogActions, MatDialogTitle, MatButton, TranslateModule, FileUploadComponent],
  templateUrl: './board-pack-ingest-dialog.component.html',
  styleUrl: './board-pack-ingest-dialog.component.scss',
  standalone: true,
})
export class BoardPackIngestDialogComponent {
  dialogRef = inject(MatDialogRef<BoardPackIngestDialogComponent>)

  uploadInfo: DocumentUploadInfo | null = null

  onFileChange(info: DocumentUploadInfo | null): void {
    this.uploadInfo = info
  }

  submit(): void {
    if (this.uploadInfo === null) {
      return
    }
    const result: BoardPackIngestDialogOutputData = {
      uploadKey: this.uploadInfo.key,
      fileName: this.uploadInfo.fileName,
    }
    this.dialogRef.close(result)
  }

  cancel(): void {
    this.dialogRef.close()
  }

  get isSubmitDisabled(): boolean {
    return this.uploadInfo === null
  }
}
